export default {
  TYPE: {
    TICKET: {
      LABEL: 'Horário da passagem',
      KEY: 'ticket',
      VALUE: 'passagem',
    },
    TRIP: { LABEL: 'Horário da Viagem', KEY: 'trip', VALUE: 'viagem' },
  },
};
